import React, { useMemo } from 'react';
import { FileText, CheckCircle, XCircle, Layers, Star } from 'lucide-react';
import ApprobationsCrudShell from './ApprobationsCrudShell';
import { ENTITY_TYPES, statusBadge, entityLabel, defaultStats, mapRecordJsonFields } from './approbationsShared';

const NS = 'modelesApprobationPage';
const API = '/api/approbations/templates';

const EMPTY = {
  template_code: '', name: '', description: '', entity_type: '', workflow_json: '[]', status: 'actif', notes: '',
};

export default function ModelesApprobationPage() {
  const entityOpts = useMemo(() => ENTITY_TYPES.map((e) => ({ value: e.value, labelKey: e.labelKey })), []);
  const statusOpts = useMemo(
    () => [
      { value: 'actif', labelKey: 'status_active' },
      { value: 'inactif', labelKey: 'status_inactive' },
    ],
    [],
  );

  return (
    <ApprobationsCrudShell
      ns={NS}
      icon={FileText}
      apiPath={API}
      codeField="template_code"
      entityPrefixKey="approvalTemplate"
      codePrefixFallback="TM"
      entityLabel="قالب الاعتماد"
      entityLabelPlural="قوالب الاعتماد"
      gradient="from-teal-500 to-teal-700"
      emptyForm={EMPTY}
      mapRecordToForm={(r) => mapRecordJsonFields(r, EMPTY)}
      computeStats={(records) => defaultStats(records, {
        totalIcon: FileText,
        fields: [
          { titleKey: 'stat_active', field: 'status', value: 'actif', icon: CheckCircle, color: 'from-green-500 to-green-600' },
          { titleKey: 'stat_inactive', field: 'status', value: 'inactif', icon: XCircle, color: 'from-red-500 to-red-600' },
          { titleKey: 'stat_system', field: 'is_system', value: 1, icon: Star, color: 'from-amber-500 to-amber-600' },
          { titleKey: 'stat_entities', field: 'entity_type', value: 'contract', icon: Layers, color: 'from-blue-500 to-blue-600' },
        ],
      })}
      columns={[
        { key: 'template_code', labelKey: 'col_code' },
        { key: 'name', labelKey: 'col_name' },
        { key: 'entity_type', labelKey: 'col_entity', render: (r, _p, _t, pl) => entityLabel(r.entity_type, pl) },
        { key: 'status', labelKey: 'col_status', render: (r, _p, _t, pl) => statusBadge(r.status, pl) },
        { key: 'created_at', labelKey: 'col_created' },
      ]}
      formSections={[
        {
          id: 'template',
          titleKey: 'section_template',
          fields: [
            { key: 'name', labelKey: 'field_name', required: true },
            { key: 'entity_type', labelKey: 'field_entity_type', type: 'select', options: entityOpts },
            { key: 'status', labelKey: 'field_status', type: 'select', options: statusOpts },
            { key: 'description', labelKey: 'field_description', type: 'textarea', fullWidth: true },
          ],
        },
        {
          id: 'workflow',
          titleKey: 'section_workflow',
          fields: [
            { key: 'workflow_json', labelKey: 'field_workflow_json', type: 'chain_steps', fullWidth: true },
            { key: 'notes', labelKey: 'field_notes', type: 'textarea', fullWidth: true },
          ],
        },
      ]}
      mapFormToPayload={(f) => ({
        template_code: f.template_code,
        name: (f.name || '').trim(),
        description: f.description || null,
        entity_type: f.entity_type || null,
        workflow_json: f.workflow_json || '[]',
        status: f.status || 'actif',
        notes: f.notes || null,
      })}
    />
  );
}
